export default {"id":"342dc420","attrs":{"viewBox":"0 0 12 12","width":"12","height":"12"}}